import { useState } from 'react';

import { type Heartbeat } from '../../../../common/types';

import { type Mode, type Settings, type UseFocusState } from './types';

export const useFocusState = (): UseFocusState => {
	const [isOpen, setOpen] = useState(false);
	const [mode, setMode] = useState<Mode>();
	const [data, setData] = useState<Heartbeat>();
	const [returnRef, setReturnRef] = useState<React.RefObject<HTMLElement>>();

	const close = () => {
		setMode(undefined);
		setData(undefined);
		setOpen(false);
		setReturnRef(undefined);
	};

	const open = (settings: Settings) => {
		setData(settings.mode === 'create' ? undefined : settings.data);
		setMode(settings.mode);
		setOpen(true);
		setReturnRef(settings.returnRef);
	};

	return {
		isOpen,
		mode,
		data,
		returnRef,
		open,
		close,
	};
};
